import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './store';
import CustomersPage from './pages/customer/customers.';
import DevicesPage from './pages/customer/devices';
import Login from './pages/login/login';
import DeviceUpdatesPage from './pages/customer/device_updates';
import DefaultRoute from './features/defaultRoute';
import ProtectedRoutes from './features/protectedRoutes';
import EventsPage from './pages/customer/events';
import InstallDevicePage from './pages/device/install/install_device';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Use HashRouter instead of BrowserRouter to prevent 404 errors on page refresh.
// If you prefer to use BrowserRouter, make sure the server is configured to redirect all routes to index.html.
// For Azure Static Web Apps, this requires adding a staticwebapp.config.json file to the public folder before
// executing `npm run build`.
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<CustomersPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/devices/searchType/:searchType/keywords/:keywords" element={<DevicesPage />} />
          <Route path="/deviceUpdates" element={<DeviceUpdatesPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/searchType/:searchType/keywords/:keywords" element={<EventsPage />} />
          <Route path="/device/install/:deviceIdOrSerial" element={<InstallDevicePage />} />
          <Route path="/device/install" element={<InstallDevicePage />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<DefaultRoute />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
